<template>
	<section style="background-color: #FAFAFA;" :class="{'is-admin': route_query.is_admin}">
		<div class="pb-56 challenge-box">
			<div class="banner-box pt-60">
				<div class="banner-img">
					<el-image :src="bannerUrl" fit="cover">
						<!-- <div slot="error" class="image-slot">
                              <img src="@/assets/images/avatar.png" alt="">
                          </div> -->
					</el-image>
				</div>
				<!-- 面包屑导航 -->
				<!-- <div class="breadcrumbs">
                      <div class="df">
                          <span class="hover" @click="handleLink('/index/index')">{{ $t('首页') }}</span>
                          <span class="iconfont icon-youbian"></span>
                          <span>{{$t('华为存储伙伴精英挑战赛')}}</span>
                      </div>
                  </div> -->

				<!-- 积分 -->
				<div class="score-box df aic" @click="handleScoreDetail" v-if="userinfo.user_id && info.have_sign_up == 10&&info.tpsn_status != 10">
					<el-avatar :size="46" :src="userinfo.user_avatar_att_url" class="fn" @error="true">
						<img src="@/assets/images/avatar.png" alt="" />
					</el-avatar>
					<div class="ml-10">
						<div class="t1">{{userinfo.user_nick_name}}</div>
						<!-- 积分 -->
						<!-- <div class="t2 mb-10">100积分</div> -->
						<!-- 查看积分明细 -->
						<el-button type="primary" class="btn1">{{$t("查看积分明细")}}</el-button>
					</div>
				</div>
			</div>


			<div class="container-box">
				<!-- 比赛简介 -->
				<div class="challenge-intro-box">
					<div class="title1">{{$t("比赛简介")}}</div>

					<div class="intro-box">
						<div class="intro-text">
							<div v-if="info" v-html="info.ta_desc"></div>
						</div>
						<div class="df mt-30">
							<div>
								<div class="intro-date">
									{{$t("比赛时间")}}：{{info.ta_start_time}} ~
									{{info.ta_end_time}}
								</div>
								<div class="intro-date">
									{{$t("报名时间")}}：{{ta_sign_start_time}} ~
									{{ta_sign_end_time}}
								</div>
							</div>
							<div class="intro-bnt df control-mask">
								<!-- <el-button type="primary" class="btn1" v-throttle="1000"  :class="showSignUpBtn?'':'stopbtn'" v-if="info.have_sign_up == 10"  @click="handleCancelSignUp" >{{ signUpTxt}}</el-button> -->
								<!-- 未报名或者报名过但是被驳回 -->
								<el-button type="primary" class="btn1" v-throttle="1000"
									:class="showSignUpBtn?'':'stopbtn'"
									v-if="(info.have_sign_up == 20 || (info.have_sign_up == 10 && info.tpsn_status === 30))"
									@click="handleSignUp">{{ signUpTxt}}</el-button>
								<el-button type="primary" class="btn1 stopbtn"
									v-else-if="info.tpsn_status == 10">{{$t("审核中")}}</el-button>
								<el-button type="primary" class="btn1 stopbtn"
									v-else-if="info.have_sign_up == 10">{{$t("已报名")}}</el-button>
								<el-button class="btn2" v-throttle="1000" @click="rules">{{$t("了解规则")}}</el-button>
							</div>
						</div>
					</div>
				</div>
				<!-- 大赛时间轴 -->
				<div class="challenge-time-box df jcsb" v-if="stage.length>1">
					<!--  @click="setStageIndex(index)" -->
					<div class="list" :class="stageIndex==index?'active':''" v-for="(item,index) in stage" :key="index" @click="setStageIndex(index)">
						<div class="title df">
							<div class="fn" style="position: relative;;max-width: 300px;">
								{{item.tas_title}}
								<p class="date">{{ item.tas_start_time }} ~ {{ item.tas_end_time }}</p>
							</div>
						</div>
						<div class="date" style="margin-top: 20px;">
							<!-- {{ item.tas_start_time }} ~ {{ item.tas_end_time }} -->
						</div>
					</div>
				</div>
			


				<div class="no_news df fdc jcc aic"
					v-if="!taskInfoList.length && !(stageIndex >= 0 && stage && stage.length > 0 && stage[stageIndex] && stage[stageIndex].poster)">
					<img src="@/assets/images/empty_data.png" alt />
					<p>{{ $t('敬请期待') }}</p>
				</div>
				<!-- 任务 -->
				<div v-for="(items,indexs) in taskInfoList" :key="indexs">
					<div class="challenge-task-box mt-56">
						<div class="title" v-if="items.dd_name">{{$t(items.dd_name)}}</div>
						<task :data="items.list" :activeInfo="info" @goAnswer="goAnswer" />
					</div>
				</div>
				<!-- <div class="challenge-task-box mt-56">
                      <div class="title">中级任务</div>
                      <task :data="dataList" />
                  </div> -->

				  				<!-- 复赛后续展示 -->
				
				<div class="challenge-intro-box"
					v-if="stageIndex >= 0 && stage && stage.length > stageIndex && stage[stageIndex] && stage[stageIndex].poster"
					@click="$jumpLink(stage[stageIndex].tasp_jump)">
					<div style="width: 100%;display: inline-block;">
						<div v-html="stage[stageIndex].poster"
								v-if="stage && stage.length > stageIndex && stage[stageIndex] && stage[stageIndex].poster"></div>
					</div>
					<!-- <div class="intro-box">
						<div class="intro-text"> -->
							<!-- <div class="title1" v-if="stage.length&&stage[stageIndex].tas_title">
								{{$t('华为存储伙伴精英挑战赛')}}-{{stage[stageIndex].tas_title}}</div> -->
							
						<!-- </div> -->
					<!-- </div> -->
				</div>

			</div>
		</div>
		
		<!-- 积分榜：有本赛段得分则展示排行，否则展示暂无排行榜 -->
		<div class="challenge-rank-box">
			<div class="challenge-task-box">
				<div class="title">{{$t("积分榜")}}</div>
			</div>
			<div class="w-1355 df" v-if="showStageLeaderboard">
				<div class="grade-box df pt-118 f1">
					<div class="grade-data">
						<img src="@/assets/images/challenge/grade-img.png" alt="">

						<div class="grade-text df grade1" v-if="gradeList&&gradeList.length>0">
							<el-avatar :size="68" :src="gradeList[0].user_avatar_att_url" class="fn" @error="true">
								<img src="@/assets/images/avatar.png" alt="" />
							</el-avatar>
							<div class="ml-12">
								<div class="name">{{gradeList[0].user_nick_name}}</div>
								<div class="company">{{gradeList[0].user_company}}</div>
								<div class="points">{{gradeList[0].tpsn_score}}{{$t(gradeList[0].tpsn_score>1?'积分s':'积分')}}</div>
							</div>
						</div>

						<div class="grade-text df grade2" v-if="gradeList&&gradeList.length>1">
							<div class="mr-12">
								<div class="name">{{gradeList[1].user_nick_name}}</div>
								<div class="company">{{gradeList[1].user_company}}</div>
								<div class="points">{{gradeList[1].tpsn_score}}{{$t(gradeList[1].tpsn_score>1?'积分s':'积分')}}</div>
							</div>
							<el-avatar :size="50" :src="gradeList[1].user_avatar_att_url" class="fn" @error="true">
								<img src="@/assets/images/avatar.png" alt="" />
							</el-avatar>

						</div>

						<div class="grade-text df grade3" v-if="gradeList&&gradeList.length>2">
							<el-avatar :size="50" :src="gradeList[2].user_avatar_att_url" class="fn" @error="true">
								<img src="@/assets/images/avatar.png" alt="" />
							</el-avatar>
							<div class="ml-12">
								<div class="name">{{gradeList[2].user_nick_name}}</div>
								<div class="company">{{gradeList[2].user_company}}</div>
								<div class="points">{{gradeList[2].tpsn_score}}{{$t(gradeList[2].tpsn_score>1?'积分s':'积分')}}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="grade-listbox" v-if="gradeList.length>3">
					<div v-for="(item, index) in gradeList" :key="index">
						<div class="list df aic" v-if="index>2">
							<span class="index mr-16">{{ index + 1 }}</span>
							<el-avatar :size="40" :src="item.user_avatar_att_url" class="fn" @error="true">
									<img src="@/assets/images/avatar.png" alt="" />
							</el-avatar>
							<div class="f1 ml-12">
									<p class="name">{{item.user_nick_name}}</p>
									<!-- 公司 -->
									<p class="company">{{item.user_company}}</p>
							</div>
							<!-- 积分 -->
							<div class="points">{{item.tpsn_score}}{{$t(item.tpsn_score>1?'积分s':'积分')}}</div>
						</div>
					</div>
					<el-button type="text" class="btn1 mt-8" @click="handleRankList">{{$t("查看更多排名")}}<i class="el-icon-arrow-right el-icon--right"></i></el-button>
				</div>
			</div>
			<div class="no_news df fdc jcc aic" v-else>
				<img src="@/assets/images/empty_data.png" alt />
				<p>{{ $t('暂无排行') }}</p>
			</div>
		</div>
	</section>
</template>

<script>
	import task from "./components/rudimentaryTask.vue";
	import {
		challengeinfo,
		challengestageList,
		challengetaskInfo,
		scoreList
	} from "@api/challenge";
	import {
		setSignUp,
		setCancelSignUp
	} from "@api/active";
	import { getMyInfo} from "@api/home";
	export default {
		name: "challenge",
		components: {
			task,
		},
		data() {
			return {
				//数据源
				info: {},
				bannerUrl: "",
				//了解规则链接
				ta_rule_link: "",
				//报名开始时间
				ta_sign_start_time: "",
				//报名结束时间
				ta_sign_end_time: "",
        ta_sign_end_timestamp: 0,
				//阶段
				stage: [],
				//切换任务类型
				stageIndex: 0,

				// 排行榜
				gradeList: [],

				route_query: {}, // 路由访问query参数

				//任务列表
				taskInfoList: [],
				answerPage: {
					10: 'daily',
					20: 'weekly',
					30: 'lecture',
					40: 'circlepart',	
					50: 'circlelecture',
					60: 'technicalarticles',
					70: 'projectorder',
					80: 'certificate',
					100: 'shortvideo', // 短视频赛贴（字典 ACTIVITYSTAGEPAPERKIND dd_value=100）
				},
				userinfo: {}, // 用户信息
			}
		},
		created() {
			this.route_query = {
				...this.$route.query
			}
		},
		computed: {
			getId() {
				return this.$route.params.id; // 获取路由参数
			},
			// 是否还能报名
			showSignUpBtn() {
			  // 如果已经报名过，直接显示按钮
			  if (this.info.have_sign_up == 10) {
			    return true;
			  }
			
			  // 获取当前时间（毫秒）
			  const now = Date.now();
			  
			  // 解析活动开始和结束时间（兼容 iOS/Android，替换 "-" 为 "/"）
			  const startTime = new Date(this.ta_sign_start_time.replace(/-/g, '/')).getTime();
			  const endTime = new Date(this.ta_sign_end_time.replace(/-/g, '/')).getTime();
			
			  // 判断当前时间是否在报名时间段内
			  if (now > startTime && now < endTime) {
			    return true;
			  }
			
			  // 特殊条件：报名状态为 10 且 tpsn_status 为 30
			  return (this.info.have_sign_up == 10 && this.info.tpsn_status === 30);
			},
			signUpTxt() {
				let time = Date.now() / 1000;
				if (this.info.have_sign_up == 10) {
					return this.$t('取消报名')
				} else if (time >= this.ta_sign_end_timestamp) {
					return this.$t('报名已结束')
				}
				return this.$t('立即报名')
			},
			showStageLeaderboard() {
				const list = this.gradeList;
				if (!Array.isArray(list) || !list.length) return false;
				return list.some((row) => Number(row.tpsn_score) > 0);
			},
		},
		mounted() {
			// 获取用户信息
			this.getuserinfo()

			this.getData();
			//获得阶段列表
			this.getstageList();
			// 设置默认的顶部菜单背景色
			setTimeout(() => {
				this.$bus.$emit('changeNavbg', 'rgba(255, 255, 255, 0.3);');
			}, 1000)

			// 组件挂载后添加滚动事件监听
			window.addEventListener('scroll', this.handleScroll);
		},
		methods: {
			async getuserinfo() {
				let res = await getMyInfo();
				if (res.status == 200) {
					// 17621655627
					this.userinfo = res.data;
				}
			},
			// 面包屑导航跳转
			handleLink(path) {
				let str = "/cn";
				let Language = localStorage.getItem("currentLanguage"); //获取本地语言
				if (Language && Language != "zh") {
					str = "/" + Language;
				}
				this.$router.push(str + path); // 使用编程式导航跳转到 About 页面
			},
			handleScroll() {
				// 检查当前滚动位置
				if (window.scrollY >= 10) {
					this.$bus.$emit('changeNavbg', 'rgba(255, 255, 255, 1);');
				} else {
					this.$bus.$emit('changeNavbg', 'rgba(255, 255, 255, 0.3);');
				}
			},
			// 获取数据
			async getData() {
				let res = await challengeinfo({
					id: this.getId,
					is_preview: this.route_query.is_preview ? this.route_query.is_preview : 0,
				});
				if (res.status == 200) {
					this.info = res.data;
					this.ta_rule_link = res.data.ta_rule_link;
					this.ta_sign_start_time = res.data.ta_sign_start_time
					this.ta_sign_end_time = res.data.ta_sign_end_time
					this.ta_sign_end_timestamp = res.data.ta_sign_end_timestamp
					this.bannerUrl = res.data.ta_web_stage_banner_attr

				}
			},
			// 阶段列表
			async getstageList() {
				let res = await challengestageList({
					ta_id: this.getId
				});
				if (res.status == 200) {
					this.stage = res.data.list;
					
					let stageIndex = res.data.current_stage_index;
					this.stageIndex = stageIndex;
					// // es6方式获取当前时间段在哪个阶段
					// res.data.forEach((item, index) => {
					// 	if (item.tas_start_time <= Date.now() / 1000 && item.tas_end_time >= Date.now() /
					// 		1000) {
					// 		stageIndex = index
					// 	} else if ((Date.now() / 1000 > item.tas_end_time && res.data.length - 1 == index) || (
					// 			Date.now() / 1000 > item.tas_end_time && (res.data[index + 1] && res.data[
					// 				index + 1].tas_start_time > Date.now() / 1000))) {
					// 		// (当前时间大于结束时间并且后面已经没有了)||(当前时间大于结束时间并且当前时间小于下一个开始时间)
					// 		stageIndex = index
					// 	}
					// })
					// this.stageIndex = stageIndex
					if (res.data.list.length > 0) {
						// 获取任务列表
						this.gettaskInfo(res.data.list[stageIndex].tas_id);
						// 获取积分列表   
						this.getchallenge(res.data.list[stageIndex].tas_id);
					}
				}
			},
			//切换赛事状态
			setStageIndex(e) {
				this.stageIndex = e
				this.gradeList = []
				// 获取任务列表
				this.gettaskInfo(this.stage[e].tas_id);
				// 获取积分列表   
				this.getchallenge(this.stage[e].tas_id);
			},
			// 获取任务列表
			async gettaskInfo(tas_id) {
				let res = await challengetaskInfo({
					ta_id: this.getId,
					tas_id: tas_id
				});
				if (res.status == 200) {
					this.taskInfoList = res.data
				}
			},

			// 获取积分
			async getchallenge(tas_id) {
				let res = await scoreList({
					ta_id: this.getId,
					tas_id: tas_id,
					page: 1,
					paginate: 18
				});
				if (res.status == 200) {
					this.gradeList = res.data.data || []
				} else {
					this.gradeList = []
				}
			},
			// 取消报名
			async handleCancelSignUp() {
				if (this.showSignUpBtn) {
					let res = await setCancelSignUp({
						ta_id: this.getId
					});
					if (res.status == 200) {
						this.$message({
							message: res.msg,
							type: "success",
							customClass: "mt-60", // 添加自定义类
						});
					}
					this.getData();
				}
			},
			// 立即报名
			async handleSignUp() {
				if (this.showSignUpBtn) {
					// setSignUp
					// let res = await setSignUp({ ta_id: this.getId });
					// if (res.status == 200) {
					//     this.$message({
					//     message: res.msg,
					//     type: "success",
					//     customClass: "mt-60", // 添加自定义类
					//     });
					// }
					// this.getData();
					this.goSignregist();
				}
			},
			// 2025-04-19需求无论如何都要进入活动报名页面去
			goSignregist(item) {
				let str = '/cn';
				let Language = localStorage.getItem('currentLanguage'); //获取本地语言
				if (Language && Language != 'zh') {
					str = '/' + Language;
				}
				let target = {}
				// 判断是否是精英赛
				target = this.$router.resolve(str + '/signregist/list/' + this.getId + '/1/1?callback=' + str +
					'/challenge/info/' + this.getId)
				window.open(target.href, '_blank');
			},
			
			// 点击前往答题
			goAnswer(item) {
				if (this.userinfo.user_id) {
					if (item.can_submit == 10&&item.dd_question_type!=30) {
						return false
					}
					// 未报名或者已报名被驳回 
					if (this.info.have_sign_up == 20 || (this.info.have_sign_up == 10 && this.info.tpsn_status == 30)) {
						this.$alert(this.$t('报名挑战赛后才能答题'), '', {
							confirmButtonText: this.$t('立即报名')
						}).then(() => {
							this.handleSignUp()
						});
					} else if (this.info.tpsn_status == 10) {
						this.$alert(this.$t('报名审核中'), '', {confirmButtonText: this.$t('确定')});
					} else {
						// 跳转对应的答题模块\
						// 1每日 2每周 3申请大讲堂 4圈子参会证明 5圈子演讲证明 6技术文章 7下单记录 8证书
						let str = '/cn';
						let Language = localStorage.getItem('currentLanguage'); //获取本地语言
						if (Language && Language!= 'zh') {
							str = '/' + Language;
						}

						this.$router.push(str + '/challenge/' + this.answerPage[item.dd_question_type] + '/' + this.getId + '/' + item.tas_id + '/' + item.tasp_id)
					}
				} else {
					this.$alert(this.$t('请先登录，再答题'), '', {
						confirmButtonText: this.$t('去登录')
					}).then(() => {
						if (this.showSignUpBtn) {
						this.goSignregist();
						}else {
						const callback = window.location.href;
						this.$navigate('/login?callback=' + callback, null, false);
						}
					});
				}
			},
			//了解规则
			rules() {
				let url = this.ta_rule_link;
				if (!url.startsWith('http')) {
					url = 'https://' + url;
				}
				window.open(url, '_blank');
			},
			// 查看积分明细
			handleScoreDetail() {
				let str = '/cn';
				let Language = localStorage.getItem('currentLanguage'); //获取本地语言
				if (Language && Language != 'zh') {
					str = '/' + Language;
				}
				const url =  str + '/points/detail/' + this.getId+'?tas_id='+this.stage[this.stageIndex].tas_id+'&tas_title='+this.stage[this.stageIndex].tas_title // 你想要跳转的 URL
        		window.open(url, '_blank');
			},
			// 查看更多排名
			handleRankList() {
				let str = '/cn';
				let Language = localStorage.getItem('currentLanguage'); //获取本地语言
				if (Language && Language != 'zh') {
					str = '/' + Language;
				}
				const url =  str + '/points/ranking/' + this.getId+'?tas_id='+this.stage[this.stageIndex].tas_id+'&tas_title='+this.stage[this.stageIndex].tas_title // 你想要跳转的 URL
        		window.open(url, '_blank');
			}
		}
	}
</script>

<style lang="scss" scoped>
	.w-1355 {
		max-width: 1355px;
		margin: 0 auto;

		.name {
			font-family: "MicrosoftYaHeiSemibold";
			color: rgb(25, 25, 25);
			font-size: 14px;
			line-height: 22px;
		}

		.company {
			color: rgb(119, 119, 119);
			font-size: 12px;
			line-height: 18px;
		}

		.points {
			color: rgb(255, 126, 75);
			font-size: 14px;
			font-weight: 700;
			line-height: 22px;
			margin-top: 4px;
		}

		.grade-text {
			position: absolute;
		}

		.grade1 {
			left: 270px;
			top: -22px;
		}

		.grade2 {
			text-align: end;
			top: 124px;
			right: 455px;
		}

		.grade3 {
			left: 455px;
			top: 188px;
		}

		.grade-data {
			width: 679px;
			position: relative;
		}
	}

	.grade-listbox {
		width: 504px;
		min-height: 774px;
		border-radius: 20px;
		background: rgb(250, 250, 250);
		padding: 32px;



		.btn1 {
			color: rgb(77, 77, 77);
			font-size: 14px;
			line-height: 22px;
			padding: 0;

			::v-deep() {
				.el-icon--right {
					margin-left: 0;
				}
			}

			i {
				color: rgb(77, 77, 77);
			}
		}

		.list {
			margin-bottom: 16px;
		}

		.index {
			color: rgb(128, 128, 128);
			font-size: 14px;
			line-height: 22px;
			width: 20px;
			text-align: center;
		}

		.name {
			color: rgb(25, 25, 25);
			font-size: 14px;
			line-height: 22px;
		}

		.points {
			color: rgb(255, 126, 75);
			font-size: 14px;
			line-height: 22px;
		}

		.company {
			color: rgb(119, 119, 119);
			font-size: 12px;
			line-height: 18px;
		}
	}

	.challenge-rank-box {

		background: #ffffff;
		padding: 40px 120px  60px;
	}

	.challenge-task-box {
		max-width: 1680px;
		margin: 0 auto;

		.title {
			color: rgb(25, 25, 25);
			font-family: "MicrosoftYaHeiSemibold";
			font-size: 24px;
			font-weight: 400;
			line-height: 36px;

			&::before {
				content: "";
				display: inline-block;
				width: 3px;
				height: 24px;
				border-radius: 2px;
				background: rgb(183, 37, 30);
				position: relative;
				top: 3px;
				margin-right: 9px;
			}
		}
	}

	.challenge-time-box {
		max-width: 1680px;
		margin: 0 auto;
		padding-top: 68px;
		padding-right: 200px;

		.list {
			margin-right: 16px;
			flex: 1;

			&:hover {
				cursor: pointer;

				.title {
					color: rgb(0, 0, 0);
				}

				.title::before {
					background: rgb(183, 37, 30);
				}
			}

			&:last-child {
				flex: none;

				.title::after {
					display: none;
				}
			}

			&.active {
				.title {
					color: rgb(0, 0, 0);
				}

				.title::before {
					background: rgb(183, 37, 30);
				}
			}


			.title {
				color: rgb(119, 119, 119);
				font-family: "MicrosoftYaHeiSemibold";
				font-size: 32px;
				font-weight: 600;
				line-height: 42px;
				letter-spacing: 1px;

				&::before {
					content: "";
					display: inline-block;
					width: 16px;
					height: 16px;
					border-radius: 50%;
					background: rgb(201, 201, 201);
					position: relative;
					margin-right: 8px;
					flex: none;
					top: 14px;
				}

				&::after {
					content: "";
					display: inline-block;
					width: 100%;
					height: 1px;
					margin-left: 7px;
					background: rgba(197, 196, 196, 0.59);
					margin-top: 22px;
				}

			}

			.title:last-child {
				display: none !important;
			}

			.date {
				color: rgb(119, 119, 119);
				font-size: 16px;
				line-height: 24px;
				margin-top: 8px;
				font-weight: lighter;
				position: absolute;
				width: max-content;
			}
		}
	}

	.container-box {
		padding: 0 120px;
	}

	.no_news {
		height: 310px;

		p {
			color: rgb(119, 119, 119);

			font-size: 14px;
			font-weight: 400;
			line-height: 24px;
			margin-top: 20px;
		}
	}

	.challenge-intro-box {
		max-width: 1680px;
		margin: 0 auto;
		padding-top: 60px;
		width: 100%;
		// display: inline-block;
		// &:after {
		// 	content: "";
		// 	display: table;
		// 	clear: both;
		// }
		.title1 {
			color: rgb(0, 0, 0);
			font-size: 32px;
			font-weight: 600;
			line-height: 42px;
			letter-spacing: 1px;
			margin-bottom: 32px;
		}

		.intro-box {
			width: 100%;
			min-height: 244px;
			border-radius: 8px;
			background-image: url('../../assets/images/challenge-intro.png');
			background-size: cover;
			background-position: center bottom;
			padding: 32px;

			.intro-text {
				color: rgb(25, 25, 25);
				font-family: HarmonyHeiTi;
				font-size: 18px;
				font-weight: 400;
				line-height: 32px;
				letter-spacing: 1px;
				min-height: 64px;
			}

			.intro-date {
				color: rgb(119, 119, 119);
				font-size: 16px;
				line-height: 24px;
				margin-top: 16px;
			}

			.intro-bnt {
				margin-top: 26px;
				margin-left: 50px;

				button {
					min-width: 100px;
					height: 44px;
					border-radius: 24px;
				}

				.btn1 {
					border: none;
					background: rgb(183, 37, 30);
					color: rgb(255, 255, 255);
					font-size: 14px;
					padding: 0 16px;

					&.stopbtn {
						background: #ccc;
						pointer-events: none !important;
						color: #666666;
					}
				}

				.btn2 {
					color: rgb(25, 25, 25);
					font-size: 14px;
					border: 0.5px solid rgba(25, 25, 25, 0.4);
					margin-left: 24px;
				}
			}
		}
	}

	.banner-box {
		width: 100%;
		background-size: cover;
		background-position: bottom center;
		position: relative;

		.banner-img {
			width: 100%;
			// height: 440px;
			min-height: 200px;

			::v-deep .el-image {
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}

		.score-box {
			z-index: 5;
			width: 305px;
			height: 96px;
			border-radius: 13px;
			backdrop-filter: blur(18px);
			background: linear-gradient(180.00deg, rgba(255, 255, 255, 0.52), rgba(255, 255, 255, 0.68) 100%);
			position: absolute;
			right: 120px;
			top: 184px;
			top: 9.5vw;
			padding-left: 31px;
			cursor: pointer;
			&:hover {
				backdrop-filter: blur(4px);
			}

			.t1 {
				font-family: "MicrosoftYaHeiSemibold";
				color: rgb(25, 25, 25);
				font-size: 18px;
				line-height: 24px;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;	
			}

			.t2 {
				color: rgb(255, 128, 0);
				font-size: 14px;
				line-height: 22px;
				margin-top: 4px;
			}

			.btn1 {
				min-width: 88px;
				height: 24px;
				border: none;
				font-size: 12px;
				color: rgba(46, 134, 222, 0.8);
				border-radius: 18px;
				background: rgba(46, 134, 222,0.08);
				padding: 0 8px;
				margin-top: 6px;
			}
		}

		.breadcrumbs {
			position: absolute;
			z-index: 5;
			max-width: 1680px;
			margin: 0 auto;
			top: 100px;
			left: 120px;

			span {
				color: rgb(77, 77, 77);
				font-size: 14px;
				line-height: 22px;

				&.hover {
					cursor: pointer;
				}
			}
		}
	}

	.challenge-box {
		background: #F9F9F9;

	}

	.is-admin {
		.activeinfo-box {
			padding: 0;
			margin-top: 0;
		}

		.control-mask {
			position: relative;

			&::after {
				content: '';
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
				z-index: 500;
			}
		}
	}
</style>